import React, { useEffect, useState } from "react";
import { Users, Circle } from "lucide-react";
import api from "@/lib/api";

// Polls /api/users/online every 20s. Renders a light card with a live
// pulse dot + count + up to 5 avatar bubbles of currently-online peers.
const POLL_MS = 20_000;

const OnlineUsersCard = () => {
  const [data, setData] = useState({ count: 0, peers: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await api.get("/users/online");
        if (!cancelled) setData(r.data || { count: 0, peers: [] });
      } catch { /* silent — non-critical card */ }
      finally { if (!cancelled) setLoading(false); }
    };
    load();
    const iv = setInterval(load, POLL_MS);
    return () => { cancelled = true; clearInterval(iv); };
  }, []);

  return (
    <div className="ios-card px-4 py-3 h-full flex items-center gap-4" data-testid="online-users-card">
      <div className="shrink-0 flex items-center gap-2">
        <span
          className="inline-flex items-center justify-center w-10 h-10 rounded-2xl"
          title="Utenti online"
        >
          <img
            src="/nav-icons/contact-card.png"
            alt=""
            aria-hidden="true"
            className="w-10 h-10 object-contain select-none"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        </span>
        <div className="leading-tight">
          <div className="text-[9px] uppercase tracking-[0.24em] text-slate-500 font-semibold flex items-center gap-1">
            <Circle className="w-2 h-2 text-emerald-500 fill-emerald-500 animate-pulse" strokeWidth={0} />
            Live
          </div>
          <div className="text-sm font-bold text-emerald-700" data-testid="online-count">
            {loading ? "…" : data.count} {data.count === 1 ? "utente online" : "utenti online"}
          </div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-end gap-1 min-w-0" data-testid="online-avatars">
        {(data.peers || []).slice(0, 5).map((p, i) => (
          p.picture ? (
            <img
              key={i}
              src={p.picture}
              alt={p.name}
              title={p.name}
              className="w-7 h-7 rounded-full border-2 border-white shadow-sm object-cover -ml-1"
            />
          ) : (
            <div
              key={i}
              title={p.name}
              className="w-7 h-7 rounded-full border-2 border-white shadow-sm bg-slate-300 text-slate-700 flex items-center justify-center text-[10px] font-bold -ml-1"
            >
              {(p.name || "?")[0]?.toUpperCase()}
            </div>
          )
        ))}
        {data.count > 5 && (
          <span className="text-[10px] text-slate-500 font-mono-num ml-1">+{data.count - 5}</span>
        )}
        {data.count === 0 && !loading && (
          <span className="text-[10px] text-slate-400 italic">Nessuno online adesso.</span>
        )}
      </div>
    </div>
  );
};

export default OnlineUsersCard;
